import { render, staticRenderFns } from "./associationNews.vue?vue&type=template&id=4674aab6&scoped=true&"
import script from "./associationNews.vue?vue&type=script&lang=js&"
export * from "./associationNews.vue?vue&type=script&lang=js&"
import style0 from "./associationNews.vue?vue&type=style&index=0&id=4674aab6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4674aab6",
  null
  
)

export default component.exports